import { getBreakPoint } from 'oolib';
import { useState, useEffect } from 'react';
import { useDebounce } from '@/utils/customHooks';

export const HeaderBreakpoint = 'md';

export const useHeaderHeight = () => {
  const debounce = useDebounce();
  
  const [headerHeight, setHeaderHeight] = useState(() => {
    const isSmallScreen = document.documentElement.clientWidth < getBreakPoint(HeaderBreakpoint);
    return isSmallScreen ? "6.3rem" : "5.3rem";
  });

  useEffect(() => {
    const updateHeaderHeight = () => {
      debounce(() => {
        const isSmallScreen = document.documentElement.clientWidth < getBreakPoint(HeaderBreakpoint);
        setHeaderHeight(isSmallScreen ? "6.3rem" : "5.3rem");
      });
    };

    window.addEventListener('resize', updateHeaderHeight);

    return () => {
      window.removeEventListener('resize', updateHeaderHeight);
    };
  }, [ debounce ]);

  return headerHeight;
}; 